import * as youplay from './youplay';
import { initializePlaceholders } from './jwplayer';
import { initializeOnScroll } from './infinityScroll';

/**
 * Initializes all players on site.
 *
 * @param {ParentNode} content
 */
export function initializePlayers(content = window.document) {
  // TODO: are we still initializing YouPlay players? This function is never run
  youplay.initializeYPPlayers(content);
}

/**
 * Initializes video package
 *
 * @param {object} options - {content, infinityScroll}
 */
export async function initialize(options) {
  if (window.video?.initialized) {
    return;
  }

  const { content = window.document, infinityScroll = window.infinityscroll } = options;

  window.video = {
    onNewContentLoaded: initializePlaceholders(),
    onBreakpointChange: initializeOnScroll(),
    initialized: true,
    youplay: youplay,
  };

  window.video.onNewContentLoaded();
  // TODO replace youplay inline scripts with placeholders and same logic as jw.
  youplay.initializeYPPlayers(content);

  infinityScroll.on('current-breakpoint-change', (breakpoint) => {
    if (window.video?.initialized) {
      window.video.onBreakpointChange(breakpoint);
    }
  });
}

export * from './jwplayer';
export * from './youplay';

export default {
  initialize,
};
export { initializeOnScroll } from './infinityScroll';
